<div *ngIf="data && data.length">
    <div
        *ngFor="let item of data; let last = last; let first = first"
        class="d-flex align-items-center gap-2 mb-3"
    >
        <div class="d-flex gap-3 align-items-center position-relative">
            <div>
                <div class="dot"></div>
                <div *ngIf="!last" class="line"></div>
            </div>
            <div>
                <div class="text-muted">{{ item.createdUtc | date: 'HH:mm' }}</div>
                <div class="text-muted">{{ item.createdUtc | date: 'dd/MM/yyyy' }}</div>
            </div>
            <div>
                <div *ngIf="first" style="font-size: 16px;" [class]="orderStatus == cancelledOrderStatus ? 'cancelled' : (orderStatus == doneOrderStatus ? 'done' : '')">{{ item.title }}</div>
                <div *ngIf="!first" style="font-size: 16px;">{{ item.title }}</div>
                <!-- <div class="text-muted">{{ item.data }}</div> -->
            </div>
        </div>
    </div>
</div>